export default function StatCard({ label, value, variant = 'count' }) {
  return (
    <div className={`stat-card stat-card-${variant}`}>
      <div className="stat-card-icon" aria-hidden>
        {variant === 'amount' ? '$' : '👤'}
      </div>
      <div className="stat-card-body">
        <div className="stat-card-value">{value}</div>
        <div className="stat-card-label">{label}</div>
      </div>
    </div>
  );
}
